import http from "@/utils/request";

const nation = {
  getNationList: (data) =>
    http.sendRequest({
      METHOD_NAME: "enumService.queryNationList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default nation;
